import React from 'react'
import './description.css'
const Description = () => {
  return (
    <div className='desc__container'>
        <p>- Serving you atleast better than your University so get your -</p>
        <h2>LMS Result</h2>
    </div>
  )
}

export default Description